import { definePreset } from '@primevue/themes'
import Aura from '@primevue/themes/aura'

export const tlPrimePresetV1 = definePreset(Aura, {
    primitive: {
        borderRadius: {
            none: '0',
            xs: '4px',
            sm: '6px',
            md: '8px',
            lg: '10px',
            xl: '14px',
        },
        white: '#ffffff',
        black: '#000000',
        gray: {
            50:  '#ffffff',
            100: '#e6e5e5',
            200: '#cccbcb',
            300: '#b3b2b2',
            400: '#999898',
            500: '#807f7f',
            600: '#666565',
            700: '#4d4c4c',
            800: '#333232',
            900: '#1a1919',
            950: '#000000',
        },
        green: {
            50: '#eefbf4',
            100: '#d6f5e3',
            200: '#b0eaca',
            300: '#7dd8ad',
            400: '#47c08b',
            500: '#24a36f',
            600: '#168559',
            700: '#126a4a',
            800: '#11543c',
            900: '#0f4533',
            950: '#07271d',
        },
        orange: {
            50: '#fffcea',
            100: '#fff5c5',
            200: '#ffeb85',
            300: '#ffda46',
            400: '#ffc71b',
            500: '#ffa500',
            600: '#e27c00',
            700: '#bb5502',
            800: '#984208',
            900: '#7c360b',
            950: '#481a00',
        },
        yellow: {
            50: '#fbffe7',
            100: '#f4ffc1',
            200: '#eeff86',
            300: '#ecff41',
            400: '#f2ff0d',
            500: '#ffff00',
            600: '#d1bf00',
            700: '#a68b02',
            800: '#896c0a',
            900: '#74580f',
            950: '#443004',
        },
        tlBlue: {
            50: '#B2CBFF',
            100: '#9DBDFF',
            200: '#74A1FF',
            300: '#4C86FF',
            400: '#236AFF',
            500: '#0051F9',
            600: '#003FC1',
            700: '#002D89',
            800: '#001A51',
            900: '#000819',
            950: '#000000',
        },
        sky: {
            50: '#f2f9f8',
            100: '#ddeff0',
            200: '#bfe1e2',
            300: '#93cacd',
            400: '#58a7ac',
            500: '#459095',
            600: '#3c767e',
            700: '#366268',
            800: '#325258',
            900: '#2d454c',
            950: '#1a2d32',
        },
        red: {
            50: '#fef2f2',
            100: '#fee2e2',
            200: '#fdcbcb',
            300: '#fba7a6',
            400: '#f77372',
            500: '#ed4443',
            600: '#da2928',
            700: '#b71f1e',
            800: '#981d1c',
            900: '#7e1f1e',
            950: '#440b0b',
        },
    },

    semantic: {
        overlay: {
            modal: {
                borderRadius: '{border.radius.md}',
                padding: '1.25rem',
                shadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
            },
        },

        primary: {
            50: '{tlBlue.50}',
            100: '{tlBlue.100}',
            200: '{tlBlue.200}',
            300: '{tlBlue.300}',
            400: '{tlBlue.400}',
            500: '{tlBlue.500}',
            600: '{tlBlue.600}',
            700: '{tlBlue.700}',
            800: '{tlBlue.800}',
            900: '{tlBlue.900}',
            950: '{tlBlue.950}',
        },
        formField: {
            paddingX: '1rem',
            paddingY: '0.6rem',
            transitionDuration: '{transition.duration}',
        },
        colorScheme: {
            light: {
                formField: {
                    borderColor: '{surface.200}',
                    focusBorderColor: '{surface.900}',
                },
                highlight: {
                    background: '{surface.100}',
                },
            },
        },
    },

    components: {
        skeleton: {
            root: {
                borderRadius: '{border.radius.sm}',
            },
            colorScheme: {
                light: {
                    root: {
                        background: 'rgba(0, 0, 0, 0.04)',
                        animationBackground: 'rgba(255, 255, 255, 0.5)',
                    },
                },
            },
        },
        tag: {
            primaryColor: '{primary.950}',
            primaryBackground: '{primary.50}',
        },
        select: {
            option: {
                selectedBackground: '{surface.100}',
                selectedFocusBackground: '{surface.100}',
            },
        },
        paginator: {
            nav: {
                button: {
                    selectedBackground: '{surface.100}',
                    borderRadius: '{border.radius.md}',
                },
            },
        },
        dialog: {
            root: {
                background: '{overlay.modal.background}',
                borderColor: '{overlay.modal.border.color}',
                color: '{overlay.modal.color}',
                borderRadius: '{overlay.modal.border.radius}',
                shadow: '{overlay.modal.shadow}',
            },
            header: {
                padding: '{overlay.modal.padding}',
                gap: '0.5rem',
            },
            title: {
                fontSize: '1.25rem',
                fontWeight: '600',
            },
            content: {
                padding: '0 {overlay.modal.padding} {overlay.modal.padding} {overlay.modal.padding}',
            },
            footer: {
                padding: '0 {overlay.modal.padding} {overlay.modal.padding} {overlay.modal.padding}',
                gap: '0.5rem',
            },
        },
        inputgroup: {
            addon: {
                padding: '0 0.5rem',
            },
        },
        button: {
            colorScheme: {
                link: {
                    color: '{primary.700}',
                },
            },
        },
        tabs: {
            tablist: {
                background: 'transparent',
                borderWidth: '0 0 3px 0',
            },
            tab: {
                color: 'rgba(0, 0, 0, 0.4)',
                hoverColor: 'rgba(0, 0, 0, 0.4)',
                activeBorderColor: 'transparent',
                padding: '16px 0',
                margin: '0 16px -4px 0',
                fontWeight: '600',
            },
            activeBar: {
                height: '3px',
                bottom: '-3px',
            },
        },
    },
})
